import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { IconErrorAlert, ButtonClose } from 'Stories/Icon/Icon.stories'

import { BlueSnapErrorsAlertProps } from './BlueSnapErrorsAlertProps'

import {
  AlertBlock,
  TextIconBlock,
  AlertIcon,
  AlertText,
  AlertClose,
} from './styles'

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
enum BlueSnapErrors {
  MISSING_SHOPPER_OR_CARD_HOLDER = 'MISSING_SHOPPER_OR_CARD_HOLDER',
  CVV_ERROR = 'CVV_ERROR',
  EXPIRED_CARD = 'EXPIRED_CARD',
  CARD_LOST_OR_STOLEN = 'CARD_LOST_OR_STOLEN',
  DO_NOT_HONOR = 'DO_NOT_HONOR',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  INVALID_CARD_NUMBER = 'INVALID_CARD_NUMBER',
  INVALID_CARD_TYPE = 'INVALID_CARD_TYPE',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  PICKUP_CARD = 'PICKUP_CARD',
  RESTRICTED_CARD = 'RESTRICTED_CARD',
  SYSTEM_TECHNICAL_ERROR = 'SYSTEM_TECHNICAL_ERROR',
  THE_ISSUER_IS_UNAVAILABLE_OR_OFFLINE = 'THE_ISSUER_IS_UNAVAILABLE_OR_OFFLINE',
  THREE_D_SECURE_FAILURE = 'THREE_D_SECURE_FAILURE',
}

const BlueSnapErrorsAlert: FunctionComponent<BlueSnapErrorsAlertProps> = ({
  name,
  handleBlueSnapError,
}) => {
  const { t } = useTranslation()

  const renderRespondError = (name: string) => {
    switch (name) {
      case BlueSnapErrors.MISSING_SHOPPER_OR_CARD_HOLDER ||
        BlueSnapErrors.CVV_ERROR ||
        BlueSnapErrors.EXPIRED_CARD:
        return t('scheduleCampaignPage.pleaseCheckYourCardDetailsAndTryAgain')
        break
      case BlueSnapErrors.CARD_LOST_OR_STOLEN:
        return t(
          'scheduleCampaignPage.pleaseRetryWithDifferentCardOrContactYourBankSupport'
        )
        break
      case BlueSnapErrors.DO_NOT_HONOR:
        return t(
          'scheduleCampaignPage.paymentProcessingFailedDueToBankDeclinePleaseUseDifferentPaymentMethodOrTryAgainIn24Hours'
        )
        break
      case BlueSnapErrors.INSUFFICIENT_FUNDS:
        return t(
          'scheduleCampaignPage.paymentProcessingFailedDueToInsufficientFundsPleaseTryWithDifferentPaymentMethod'
        )
        break
      case BlueSnapErrors.INVALID_CARD_NUMBER:
      case BlueSnapErrors.INVALID_CARD_TYPE:
        return t(
          'scheduleCampaignPage.pleaseCheckYourCardDetailsAndTryAgainIfTheIssuePersistTryToUseDifferentPaymentMethod'
        )
        break
      case BlueSnapErrors.LIMIT_EXCEEDED:
      case BlueSnapErrors.PICKUP_CARD:
        return t(
          'scheduleCampaignPage.paymentProcessingFailedTheCardHasBeenReportedLostOrStolenPleaseRetryWithDifferentCard'
        )
      case BlueSnapErrors.RESTRICTED_CARD:
        return t(
          'scheduleCampaignPage.paymentProcessingFailedBecauseOfIssuesWithCardPleaseTryWithifferentPaymentMethod'
        )
        break
      case BlueSnapErrors.SYSTEM_TECHNICAL_ERROR:
      case BlueSnapErrors.THE_ISSUER_IS_UNAVAILABLE_OR_OFFLINE:
        return t(
          'scheduleCampaignPage.paymentProcessingFailedBecauseOfSystemOrConnectionErrorPleaseTryToRepeatThePayment'
        )
        break
      case BlueSnapErrors.THREE_D_SECURE_FAILURE:
        return t(
          'scheduleCampaignPage.paymentProcessingFailedPleaseTryWithDifferentPaymentMethodOrContactYourBankSupport'
        )
        break
      default:
        return t(
          'scheduleCampaignPage.paymentProcessingFailedPleaseTryWithDifferentPaymentMethodOrContactYourBankSupport'
        )
    }
  }

  return (
    <AlertBlock>
      <TextIconBlock>
        <AlertIcon>
          <IconErrorAlert />
        </AlertIcon>
        <AlertText>{renderRespondError(name)}</AlertText>
      </TextIconBlock>

      <AlertClose type="button" onClick={handleBlueSnapError}>
        <ButtonClose />
      </AlertClose>
    </AlertBlock>
  )
}

export default BlueSnapErrorsAlert
